import { Capacitor } from "@capacitor/core";

const TOKEN_KEY = "auth_token";

export const isNative = Capacitor.isNativePlatform();

export function setNativeToken(token: string) {
  if (isNative) {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

export function getNativeToken(): string | null {
  if (isNative) {
    return localStorage.getItem(TOKEN_KEY);
  }
  return null;
}

export function clearNativeToken() {
  localStorage.removeItem(TOKEN_KEY);
}
